var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDisplay)?_c('div',{staticClass:"wrap_a2hs",on:{"click":_vm.del}},[_c('img',{attrs:{"src":"/assets/img/common/img_a2hs.png","alt":"ホーム画面に追加するとアプリとしてご利用できます。"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }